import React from 'react'
import PropTypes from 'prop-types'

function PrintHeader({ appConfig }) {
  return (
    <div className="print-header">
      <div className="appBrandingGroup">
        <img src={appConfig.logoUrl} className="appLogo" alt={appConfig.appName} />
        <div className="aboutAppHeading">
          <div className="aboutAppAcronym">
            <span className="aboutAppAcronym__label"></span>
            {appConfig.appCode}
          </div>
          <div className="aboutAppFullName">{appConfig.appName}</div>
        </div>
      </div>
    </div>
  )
}

PrintHeader.propTypes = {
  appConfig: PropTypes.shape({
    logoUrl: PropTypes.string.isRequired,
    appCode: PropTypes.string.isRequired,
    appName: PropTypes.string.isRequired,
  }).isRequired,
}

export default PrintHeader
